import type { RuleVariable } from "../hooks/useRuleVariables";

/**
 * Case-insensitive check: whether `trimmedName` matches another variable in the rule
 * (database, simple, formula, reaction, etc.). Excludes `excludeVariableId` when editing.
 * Matches {@link useRuleVariables} add/update behavior.
 */
export function isVariableNameTakenInRule(
	trimmedName: string,
	existingVariables: RuleVariable[],
	excludeVariableId?: string | null,
): boolean {
	const normalized = trimmedName.trim().toLowerCase();
	if (!normalized) {
		return false;
	}
	return existingVariables.some(
		(v) => v.id !== excludeVariableId && v.name.toLowerCase() === normalized,
	);
}
